import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import BoltIcon from '@mui/icons-material/Bolt';

const SignalIcon = ({ signal }) => {
  const isBuySignal = signal.type.toUpperCase() === 'BUY';
  const strength = parseFloat(signal.strength) || 0;
  
  const style = {
    color: isBuySignal ? '#16a34a' : '#dc2626', // green-600 : red-600
    opacity: 0.3 + (strength * 0.7),
    width: '20px',
    height: '20px',
    padding: '2px',
    borderRadius: '50%'
  };

  // Pattern-based icon matching for signal name variations
  const getIconForSignal = (signalName) => {
    const name = signalName.toLowerCase();

    if (name.includes('golden cross')) return AddIcon;           // + cross (bullish)
    if (name.includes('death cross')) return CloseIcon;          // X cross (bearish)
    if (name.includes('double bottom')) return SignalCellularAltIcon;  // W-like pattern
    if (name.includes('gap up')) return RocketLaunchIcon;        // Rocket up
    if (name.includes('gap down')) return KeyboardDoubleArrowDownIcon; // Fast down
    if (name.includes('breakout')) return BoltIcon;              // Lightning bolt
    if (name.includes('oversold')) return RotateRightIcon;       // Turning up
    if (name.includes('overbought')) return RotateLeftIcon;      // Turning down
    if (name.includes('resistance') || name.includes('rejection')) return VerticalAlignBottomIcon;
    if (name.includes('support') || name.includes('bounce')) return VerticalAlignTopIcon;

    return BoltIcon; // Default fallback
  };

  const IconComponent = getIconForSignal(signal.name);
  
  return (
    <div className="relative group">
      <IconComponent sx={style} />
      <div className="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded p-2 z-10 -mt-1 ml-6 whitespace-nowrap">
        {signal.name}<br/>
        Strength: {(signal.strength * 100).toFixed(0)}%<br/>
        Price: ${signal.price.toFixed(2)}
      </div>
    </div>
  );
};

const TechnicalSignalIcons = ({ signals }) => {
  if (!signals || signals.length === 0) return null;

  // Sort by strength and take top 3
  const topSignals = [...signals]
    .sort((a, b) => b.strength - a.strength)
    .slice(0, 3);

  // If there are more signals, add a count indicator
  const hasMoreSignals = signals.length > 3;

  return (
    <div className="flex gap-1 items-center">
      {topSignals.map((signal, index) => (
        <SignalIcon key={`${signal.created_at}-${index}`} signal={signal} />
      ))}
      {hasMoreSignals && (
        <div className="text-xs text-gray-500 ml-1" title={`${signals.length - 3} more signals`}>
          +{signals.length - 3}
        </div>
      )}
    </div>
  );
};

export default TechnicalSignalIcons; 